export const PORTAL_ONBOARDING_LAYOUT = {
  highlightPadding: 4,
  pointerWidth: 12,
  popoverOffset: 24,
  viewportPadding: 16,
  pointerRotation: {
    top: -90,
    right: 0,
    bottom: 90,
    left: 180,
  },
  pointerStaticSide: {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right',
  },
} as const

export const PORTAL_ONBOARDING_PHASE = {
  idle: 'idle',
  welcome: 'welcome',
  active: 'active',
  completed: 'completed',
} as const

export type PortalOnboardingPhase = (typeof PORTAL_ONBOARDING_PHASE)[keyof typeof PORTAL_ONBOARDING_PHASE]

export const PORTAL_ONBOARDING_VISIBLE_PHASES = [
  PORTAL_ONBOARDING_PHASE.welcome,
  PORTAL_ONBOARDING_PHASE.active,
] as const satisfies readonly PortalOnboardingPhase[]

export function isPortalOnboardingVisiblePhase(phase: PortalOnboardingPhase): boolean {
  return (PORTAL_ONBOARDING_VISIBLE_PHASES as readonly PortalOnboardingPhase[]).includes(phase)
}

export const PORTAL_ONBOARDING_STEPS = [
  'portal',
  'addNew',
  'serviceMap',
  'grafts',
  'vision',
  'modules',
  'gateway',
  'insights',
  'academy',
] as const

export type PortalOnboardingStepId = (typeof PORTAL_ONBOARDING_STEPS)[number]

/** Values for `data-portal-onboarding` -" keyed by step / i18n id. */
export const PORTAL_ONBOARDING_DOM_TARGET: Record<PortalOnboardingStepId, string> = {
  portal: 'portal-nav',
  addNew: 'add-new',
  serviceMap: 'service-map',
  grafts: 'grafts',
  vision: 'vision-nav',
  modules: 'modules-nav',
  gateway: 'gateway-nav',
  insights: 'insights-nav',
  academy: 'academy-nav',
}

export type PortalOnboardingDomTargetId = (typeof PORTAL_ONBOARDING_DOM_TARGET)[PortalOnboardingStepId]
